import { FormsModule, NgForm } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoginServico } from '../servicos/login.servico';
import { Router, ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material';
import { UtilServico } from '../servicos/util.servico';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import swal from 'sweetalert2';

declare var jquery: any;
declare var $: any;
//declare var swal: any;

@Component({
  selector: 'app-adm',
  encapsulation: ViewEncapsulation.None,

  templateUrl: './adm.component.html',
  styleUrls: ['./adm.component.scss']
})
export class AdmComponent implements OnInit {
  LOGIN: any;
  DADOSESQUECEUSENHA: any;
  Mostrar: any;
  TotalRegistro: number;
  Url: string;
  RecadastramentoLink: string;

  constructor(
    private http: Http,
    private loginServico: LoginServico,
    private router: Router,
    private UtilServico: UtilServico
  ) {
    this.http.get(`assets/config.json?ticks=${new Date().getTime()}`).subscribe(data => { 
      const json = data.json();
      this.Url = json.BASE_WEB_API,
      this.RecadastramentoLink = json.RECADASTRAMENTO_LINK
    });
  }

  ngOnInit() {
    this.loginServico.logout();
    this.LOGIN = {};
    this.DADOSESQUECEUSENHA = {};
  }
  AcessarSistema() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Methods': 'PUT, GET, POST, DELETE, OPTIONS', 'Access-Control-Allow-Origin': '*' });
    let options = new RequestOptions({ headers: headers });
    this.http.post(this.Url + "/api/Login/Autenticar", JSON.stringify({ usuario: this.LOGIN.USUARIO, senha: this.LOGIN.SENHA }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          //console.log(data);
          localStorage.setItem('AcessoAdm', JSON.stringify(Object.assign(data, { URL: this.Url, RECADASTRAMENTO_LINK: this.RecadastramentoLink })));
          this.router.navigate(['/inicial']);
          this.Mostrar = false;
        },
        error => {
          this.Mostrar = false;
          if (error.status == 0) {
            swal.fire({
              title: "Atenção!",
              type: "warning",
              text: "Não foi possível conectar no servidor banco de dados!"
            });
          }
          else {
            swal.fire({
              title: "Atenção!",
              type: "warning",
              text: "Usuário não encontrado ou senha inválida!"
            });
          }
        }
      );
  }

  AlterSenha() {
    //this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    if (this.DADOSESQUECEUSENHA.NOVA !== this.DADOSESQUECEUSENHA.CONFIRMA) {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!"
      });
    }
    else {
      this.http.post(this.Url + "/api/Login/GetTrocarSenha", JSON.stringify({ LOGIN: this.DADOSESQUECEUSENHA.CPF, SENHA: this.DADOSESQUECEUSENHA.NOVA, DATA_NASC: this.DADOSESQUECEUSENHA.DATA_NASC }), options)
        .map((response: Response) => response.json())
        .subscribe(
          data => {
            this.Mostrar = false;
            this.TotalRegistro = data.Total;
            if (this.TotalRegistro == 0) {
              swal.fire({
                title: "Atenção!",
                type: "error",
                text: "Dados não conferem com cadastro em nosso banco de dados!"
              });
            }
            else {
              this.LOGIN.USUARIO = this.DADOSESQUECEUSENHA.CPF;
              this.LOGIN.SENHA = this.DADOSESQUECEUSENHA.NOVA;
              $(document.body).removeClass("modal-open");
              $(".modal-backdrop").remove();
              this.AcessarSistema();
            }
          },
          error => {
            this.Mostrar = false;
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// D:/Agents/es/_work/11/s/ANGULAR/src/app/login/adm.component.ts